import React, { Component } from "react";
import ReactSVG from "react-svg";
import { NavLink } from "react-router-dom";
import Modal from "react-responsive-modal";

import Referral from "../referral/Referral";
import "./Footer.css";
import { Desktop, Mobile } from "../../utils/styles";

const noDivider = ["/", "/contact-us", "/terms-of-use", "/privacy"];

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  render() {
    const showDivider = !noDivider.includes(this.props.location);
    const { open } = this.state;
    return (

      <div className="ha-footbar" style={this.props.location == "/" ? {} : {display:'none'} }>
        {showDivider ? <hr /> : <div className="divider" />}

        <div className="container">
          <div className="left">
            <NavLink to="/">
              <ReactSVG
                path="/images/helloava-logo.svg"
                wrapperClassName="svg-wrapper"
              />
            </NavLink>
          </div>
          <div className="right">
            <Desktop>
              <div className="top-section">
                <div className="column">
                  <a href="/our-story">Our Story</a>
                  <a href="/team">Team</a>
                  <a href="/referral">Get $20</a>
                  <a href="/gift">Gift</a>
                </div>
                <div className="column">
                  <a href="/contact-us">Contact Us</a>
                  <a href="/affiliate">Brand Partnership</a>
                </div>
                <div className="column last">
                  <a href="/price-matching">Price Match Guarantee</a>
                  <a href="/return-policy">Return Policy</a>
                  <a href="/privacy">Privacy Policy</a>
                  <a href="/terms-of-use">Terms of Use</a>
                  <a className="made-with-love">Made with &#9829; in NYC</a>
                </div>
              </div>
            </Desktop>

            <Mobile>
              <div className="top-section">
                <div className="footer-link-container">
                  <div className="link-row">
                    <div className="column">
                      <a href="/our-story">Our Story</a>
                      <a href="/team">Team</a>
                      {/* <a onClick={this.onOpenModal}>Get $20</a> */}
                      <a href="/referral">Get $20</a>
                      <a href="/gift">Gift</a>
                    </div>
                  </div>
                  <div className="link-row">
                    <div className="column">
                      <a href="/contact-us">Contact Us</a>
                    </div>
                  </div>
                </div>
                <div className="column last">
                  <a href="/price-matching">Price Match Guarantee</a>
                  <a href="/return-policy">Return Policy</a>
                  <a href="/privacy">Privacy Policy</a>
                  <a href="/terms-of-use">Terms of Use</a>
                  <a className="made-with-love">Made with &#9829; in NYC</a>
                </div>
              </div>
            </Mobile>
            <div className="bottom-section">
              <div className="icons">
                <a
                  href="https://www.instagram.com/helloavabeauty/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ReactSVG
                    path="/images/common/instagram.svg"
                    wrapperClassName="svg-wrapper"
                  />
                </a>
                <a
                  href="https://m.me/helloavabeauty"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ReactSVG
                    path="/images/common/facebook.svg"
                    wrapperClassName="svg-wrapper"
                    style={{ width: "26px" }}
                  />
                </a>
                <a
                  href="https://sendbottles.com/r/2194?t=Hi%20Ava"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ReactSVG
                    path="/images/common/mail.svg"
                    wrapperClassName="svg-wrapper"
                  />
                </a>
              </div>
              <div className="copyright">© 2022 Helloava, Inc.</div>
            </div>
          </div>
        </div>
        <Modal
          open={open}
          onClose={this.onCloseModal}
          little
          classNames={{ overlay: "ha-overlay", modal: "referral-modal" }}
        >
          <Referral closeModal={this.onCloseModal} />
        </Modal>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js